import { ErrorMessage } from './ErrorMessage';

const FieldWrapper = ({ className = '', children }: any) => <div className={`field-wrapper relative ${className}`}>{children}</div>;
const FieldData = ({ label, info, error, labelClassName }: any) => (
  <>
    {label && <label className={`field-label ${labelClassName}`}>{label}</label>}
    {info && <div className="field-info">{info}</div>}
    {error && <ErrorMessage message={error} />}
  </>
);
export const BasicInput = ({
  name,
  value,
  label,
  info,
  error,
  className = '',
  labelClassName = '',
  addOnRight = null,
  title,
  required,
  ...rest
}: any) => {
  return (
    <div className="w-full">
      {title && (
        <p className="mb-[6px] !text-xl font-medium">
          {title} {required ? '*' : ''}
        </p>
      )}
      <FieldWrapper className={`${className} ${Boolean(value) ? 'has-value' : ''} ${error ? 'has-error' : ''}`}>
        <div className={`field-group flex ${Boolean(label) ? 'labeled' : ''}`}>
          <input
            type="text"
            {...{ name }}
            {...rest}
            value={value || ''}
            className={`form-field ${rest?.disabled ? '!text-gray-400' : ''}`}
            onChange={(e: any) => {
              if (e.target.value) {
                (e.target.closest('.field-wrapper') as HTMLDivElement).classList.add('has-value');
              } else {
                (e.target.closest('.field-wrapper') as HTMLDivElement).classList.remove('has-value');
              }
              if (rest.onChange) {
                rest.onChange(e);
              }
            }}
            onFocus={(e: any) => (e.target.parentNode as HTMLDivElement).classList.add('focus')}
            onBlur={(e: any) => (e.target.parentNode as HTMLDivElement).classList.remove('focus')}
          />
          {addOnRight}
        </div>
        <FieldData {...{ label, info, error, labelClassName }} />
      </FieldWrapper>
    </div>
  );
};
